import { render, staticRenderFns } from "./transferConfirm.vue?vue&type=template&id=7ae84ddf&scoped=true"
import script from "./transferConfirm.vue?vue&type=script&lang=js"
export * from "./transferConfirm.vue?vue&type=script&lang=js"
import style0 from "./transferConfirm.vue?vue&type=style&index=0&id=7ae84ddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae84ddf",
  null
  
)

export default component.exports